export default __webpack_public_path__ + "static/media/underline.ae5f8cd2.svg";